import Button from 'components/ui/Button'
import InputTextField from 'components/ui/InputTextField'
import React from 'react'
import { GoCheckCircleFill } from 'react-icons/go'

const ResetForm = ({ setTab }) => {
    const submitHandler = (e) => {
        e.preventDefault()
        setTab()
    }
    return (
        <form className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32" onSubmit={submitHandler}>
            <div className="text-4xl font-bold">
                Reset Password
            </div>
            <div className="mt-4 text-lg text-lightGrey">
                It is a long established fact that a reader will be distracted.
            </div>
            <InputTextField
                label="New Password*"
                type="password"
            />

            <div className='mt-2 grid grid-cols-2'>
                <div className='flex items-center text-lg gap-2 text-[#8F8F8F]'>
                    <div>
                        <GoCheckCircleFill size={20} color='#BDBDBD' />
                    </div>
                    <div>
                        One Uppercase
                    </div>
                </div>
                <div className='flex items-center text-lg gap-2 text-[#8F8F8F]'>
                    <div>
                        <GoCheckCircleFill size={20} color='#BDBDBD' />
                    </div>
                    <div>
                        One Lowercase
                    </div>
                </div>
            </div>
            <div className='mt-2 grid grid-cols-2'>
                <div className='flex items-center text-lg gap-2 text-[#8F8F8F]'>
                    <div>
                        <GoCheckCircleFill size={20} color='#BDBDBD' />
                    </div>
                    <div>
                        One Number
                    </div>
                </div>
                <div className='flex items-center text-lg gap-2 text-[#8F8F8F]'>
                    <div>
                        <GoCheckCircleFill size={20} color='#BDBDBD' />
                    </div>
                    <div>
                        8 Characters
                    </div>
                </div>
            </div>
            <InputTextField
                label="New Password*"
                type="password"
            />
            <div className="mt-8">
                <Button title="Update Password" type="submit" />
            </div>
        </form>
    )
}

export default ResetForm